import gql from 'graphql-tag'

export const GET_SERVICES = gql`
  query($filter: Filter) {
    services(filter: $filter) {
      id
      state
      status
      placeId
      employeeId
      startDate
      specialty
      endDate
    }
  }
`

export const GET_SERVICE = gql`
  query($id: String!) {
    services(id: $id) {
      id
      state
      status
      placeId
      employeeId
      startDate
      specialty
      endDate
    }
  }
`
